import React, { ChangeEvent, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FerramentasDeDetalhe, RadioGroup, CheckBox, ILstLiga } from "../../shered/components";
import { VForm, VTextField, VScope, useVForm } from "../../shered/forms";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { IDetalheMensagemPorUsuario, IDetalheMensagemPorUsuarioCreate, IDetalheUsuario, UsuarioService } from "../../shered/services/api/usuario/UsuarioService";
import CookieService from "../../shered/services/autenticacao/CookieService";
import {
    Box, FormControl, FormControlLabel, Paper, Switch, Typography, useTheme,
    Tab,
    Autocomplete,
    Checkbox as MuiCheckBox,
    Table, TableBody, TableCell,
    TableContainer, TableFooter, TableHead,
    TableRow, Tabs,
    tableCellClasses,
    tabsClasses,
    Select,
    MenuItem,
    InputLabel,
    Tooltip,
    IconButton,
    Icon,
    TextField,
    CircularProgress,
    Button,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { Loading } from "../../shered/components/loading/Loading";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import { ILstDrop, lstPosicaoAmericana, lstPosicaoAmericano, lstReferenciasPosicao, TDropOptions, TipoSalario, UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { LigaService } from "../../shered/services/api/liga/LigaService";
import { FranquiaService, IDadosCadastroPorFranquia, IDadosFranquiaJogador, IDadosFranquiaMultasAnual, IDadosResumoPicksAno, IDetalheFranquia } from "../../shered/services/api/franquia/FranquiaService";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";
import { styled } from '@mui/material/styles';
import { moedaRealLocaleValue } from "../../shered/components/input-valor-moeda/Current-Mask";
import { IListagemJogador, JogadorService } from "../../shered/services/api/jogador/JogadorService";
import { NumericFormat, NumericFormatProps } from 'react-number-format';
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}
function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {
                // value === index && (
                <Box sx={{ p: 3 }}>
                    <Grid container>{children}</Grid>
                </Box>
                //)
            }
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
        fontSize: UtilidadeService.isMobile() ? 10 : 14,
        padding: UtilidadeService.isMobile() ? "5px" : 8,

    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: UtilidadeService.isMobile() ? 10 : 14,
        padding: "4px",

    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
        padding: UtilidadeService.isMobile() ? "8px 5px" : "12px 8px",
    },
}));

interface CustomProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
}

const NumericFormatCustom = React.forwardRef<NumericFormatProps, CustomProps>(
    function NumericFormatCustom(props, ref) {
        const { onChange, ...other } = props;

        return (
            <NumericFormat
                {...other}
                getInputRef={ref}
                onValueChange={(values) => {
                    onChange({
                        target: {
                            name: props.name,
                            value: values.value,
                        },
                    });
                }}

                thousandSeparator={'.'}
                decimalSeparator={','}
                valueIsNumericString
                prefix="R$"
            />
        );
    },
);

export const DetalheDeConfigComissario: React.FC = () => {
    const user = CookieService.get("access_user");
    const { themeName } = useAppThemeContext();
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const [value, setValue] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const theme = useTheme();
    const [removeLoading, setRemoveLoading] = useState(false);
    const navigate = useNavigate();
    const { formRef, save, saveAndClose, isSaveAndClose } = useVForm();
    const { logout } = useAuthContext();
    const [redirecionar, setRedirecionar] = useState("0");
    const [adm, setAdm] = useState(user.administrador);
    const [cod_Usuario, setCod_Usuario] = useState(0);
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [usuarioComissario, setUsuarioComissario] = useState(false);
    const [franquiaFiltro, setFranquiaFiltro] = useState(0);
    const [franquiaFiltroRetornoDispensa, setFranquiaFiltroRetornoDispensa] = useState(0);
    const [franquiaFiltroRetornoInserir, setFranquiaFiltroRetornoInserir] = useState(0);
    const [posicao1, setPosicao1] = useState(0);
    const [posicao2, setPosicao2] = useState(0);
    const [posicao3, setPosicao3] = useState(0);
    const [chkRestrito, setChkRestrito] = useState(false);
    const [chkDraftado, setChkDraftado] = useState(false);
    const [valorSalario1, setValorSalario1] = useState("");
    const [tipoSalario1, setTipoSalario1] = useState(0);
    const [valorSalario2, setValorSalario2] = useState("");
    const [tipoSalario2, setTipoSalario2] = useState(0);
    const [valorSalario3, setValorSalario3] = useState("");
    const [tipoSalario3, setTipoSalario3] = useState(0);
    const [valorSalario4, setValorSalario4] = useState("");
    const [tipoSalario4, setTipoSalario4] = useState(0);
    const [valorSalario5, setValorSalario5] = useState("");
    const [tipoSalario5, setTipoSalario5] = useState(0);
    const [valorSalario6, setValorSalario6] = useState("");
    const [tipoSalario6, setTipoSalario6] = useState(0);
    const [qtdAnoContrato, setQtdAnoContrato] = useState(0);
    const [listaPosicoes, setListaPosicoes] = useState<ILstDrop[]>([]);
    const [franquia, setFranquia] = useState<IDetalheFranquia>();
    const [irregularidades, setIrregularidades] = useState<any[]>([]);
    const [lstFraqnuias, setLstFranquias] = useState<ILstDrop[]>([]);
    const [totalCountJogadores, setTotalCountJogadores] = useState(0);
    const [estatisticasRows, setEstatisticasRows] = useState<IDadosFranquiaJogador[]>([]);
    const [franquiaMultasAnualRows, setFranquiaMultasAnualRows] = useState<IDadosFranquiaMultasAnual>();
    const [mercadoAberto, setMercadoAberto] = useState(false);
    const [twoWay, setTwoWay] = useState(true);
    const [temporadaIniciada, setTemporadaIniciada] = useState(false);
    const [showImagemJogador, setShowImagemJogador] = useState<any>("../../semimagem.png");
    const [nomeLiga, setNomeLiga] = useState("");
    const [ano1, setAno1] = useState("");
    const [ano2, setAno2] = useState("");
    const [ano3, setAno3] = useState("");
    const [ano4, setAno4] = useState("");
    const [ano5, setAno5] = useState("");
    const [resumo_Picks_Ano1, setResumo_Picks_Ano1] = useState<IDadosResumoPicksAno[]>([]);
    const [resumo_Picks_Ano2, setResumo_Picks_Ano2] = useState<IDadosResumoPicksAno[]>([]);
    const [resumo_Picks_Ano3, setResumo_Picks_Ano3] = useState<IDadosResumoPicksAno[]>([]);
    const [resumo_Picks_Ano4, setResumo_Picks_Ano4] = useState<IDadosResumoPicksAno[]>([]);
    const [resumo_Picks_Ano5, setResumo_Picks_Ano5] = useState<IDadosResumoPicksAno[]>([]);
    const [rowsJogadores, setRowsJogadores] = useState<IListagemJogador[]>([]);
    const [rows, setRows] = useState<IListagemJogador[]>([]);
    const [opcoesAutoCompleteJogador, setOpcoesAutoCompleteJogador] = useState<TDropOptions[]>([])
    const [selectedIdComplete, setSelectedIdComplete] = useState<number | undefined>(0);
    const [opcoesAutoCompleteInserirJogador, setOpcoesAutoCompleteInserirJogador] = useState<TDropOptions[]>([])
    const [selectedIdCompleteInserir, setSelectedIdCompleteInserir] = useState<number | undefined>(0);
    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [showModalEvent, setShowModalEvent] = useState(false);
    const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
        acao: false,
        label: "",
        tipo: "info",
        mensagem: "Deseja ronovar com o jogador ",
        display: "none",
        titulo: "Atenção"
    });

    const autoCompleteSelectedOption = useMemo(() => {
        if (!selectedIdComplete) return null;

        const selectedOption = opcoesAutoCompleteJogador.find(opcao => opcao.codigo === selectedIdComplete);
        if (!selectedOption) return null;

        return selectedOption;
    }, [selectedIdComplete, opcoesAutoCompleteJogador]);

    const autoCompleteSelectedOptionInserir = useMemo(() => {
        if (!selectedIdCompleteInserir) return null;

        const selectedOption = opcoesAutoCompleteInserirJogador.find(opcao => opcao.codigo === selectedIdCompleteInserir);
        if (!selectedOption) return null;

        return selectedOption;
    }, [selectedIdCompleteInserir, opcoesAutoCompleteInserirJogador]);

    useEffect(() => {
        const user = CookieService.get("access_user");
        setAdm(user.administrador);
        setCod_Usuario(user.codUsuario);
        setIsLoading(false);
        setRemoveLoading(true);

        const fetchData = async () => {
            await LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                .then((result) => {
                    setIsLoading(false);
                    const liga = result.dado;
                    setNomeLiga(liga.nome);
                    setMercadoAberto(liga.abertura_Mercado);
                    setTemporadaIniciada(liga.status === 3);
                    setTwoWay(liga.two_Way);
                    setListaPosicoes(liga.codigo_Tipo_Posicao_Confronto !== 2 ? lstReferenciasPosicao : lstPosicaoAmericano)


                    if (!liga.comissario_Usuario && !adm) {
                        setShowModalMensagem(true);
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "warning",
                            mensagem: "Seu usuário não é comissário!",
                            display: "none",
                            titulo: "Atenção"
                        });

                        setTimeout(() => {
                            navigate(-1);
                        }, 3500);

                        return;
                    }

                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    if (errors.response !== undefined) {
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        else {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: errors.response.data.mensagem,
                                display: "none",
                                titulo: "Atenção"
                            });

                            return;
                        }
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados da franquia. Favor tentar mais tarde e se persistir o problema, entrar em contato com a TI",
                        display: "none",
                        titulo: "Atenção"
                    });

                    return;
                });
            FranquiaService.getByIdLiga(Number(codigoLiga))
                .then((result) => {
                    const franquias = result.dado;
                    let lstFranquiasAux = franquias.map((f, i) => ({ codigo: f.codigo, label: f.nome }));
                    setLstFranquias(lstFranquiasAux);

                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                });

            CarregarDadosJogadores(true);

        }
        fetchData();
    }, []);


    const CarregarDadosJogadores = async (atualizarAutoComplete: boolean) => {
        await JogadorService.getTodosJogadores(Number(codigoLiga), selectedIdComplete, 0, 0, "", 1)
            .then(result => {
                setRowsJogadores(result.data.dado);
                const lstDrop: TDropOptions[] = result.data.dado.sort((a, b) => a.nome > b.nome ? 1 : -1)
                    .map((f, i) => ({ codigo: f.codigo, label: f.nome, descricao: f.codigo_NBA.toString() }));
                if (atualizarAutoComplete === true) {
                    setOpcoesAutoCompleteJogador(lstDrop);
                }
            }).catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                if (errors.response.data.statusHTTP === 401) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Sessão Expirada! 1",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                if (errors.response.data.mensagem !== undefined) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                }
                else {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados dos jodadores! Favor entrar em contato com a TI",
                        display: "none",
                        titulo: "Atenção"
                    });
                }
            });

        await JogadorService.getAllPorLiga(Number(codigoLiga), selectedIdCompleteInserir, "", 0, 0)
            .then((result) => {
                setRows(result.data.dado);
                const resultado = result.data.dado;
                let lstDrop: TDropOptions[] = resultado
                    .map((f, i) => ({ codigo: f.codigo, label: f.nome, descricao: f.codigo_NBA.toString() }));
                if (atualizarAutoComplete === true) {
                    setOpcoesAutoCompleteInserirJogador(lstDrop);
                }
            }).catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });

                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                else {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados do jogador! Favor entrar em contato com a TI",
                        display: "none",
                        titulo: "Atenção"
                    });
                }
            });
    }
    const handleCarregarDadosJogadores = (codigoFranquia: number) => {
        //LimparListas();

        setIsLoading(true);
        setRemoveLoading(false);

        if (codigoFranquia === 0) {
            setIsLoading(false);
            setRemoveLoading(true);
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Favor informar uma franquia!",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }

        FranquiaService.getByIdFranquia(codigoFranquia)
            .then((result) => {
                let franquia = result.dado;
                setIsLoading(false);
                setRemoveLoading(true);
                setFranquia(franquia);
                setIrregularidades(franquia.irregularidades);
                setEstatisticasRows(franquia.franquia_Jogador.length > 0 ? franquia.franquia_Jogador : []);
                setFranquiaMultasAnualRows(franquia.franquia_Multas_Anual);
                setTotalCountJogadores(franquia.franquia_Jogador.length > 0 ? franquia.franquia_Jogador.length : 0);


            }).catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                if (errors.response.data.statusHTTP === 401) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Sessão Expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                if (errors.response.data.mensagem !== undefined) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                }
                else {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados da franquia! Favor entrar em contato com a TI",
                        display: "none",
                        titulo: "Atenção"
                    });
                }
            });
    }

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
        }
    }

    const toggleModalEvent = () => {
        setShowModalEvent(modalVisivel => !modalVisivel);
        handleCarregarDadosJogadores(franquiaFiltro);
        //navigate(0);

    }

    const handleSave = async (dados: IDetalheMensagemPorUsuarioCreate[]) => {
        // UsuarioService.createConfiguracaoMensagem(listaPermissoes)
        //     .then((result) => {
        //         setIsLoading(false);
        //         setRemoveLoading(true);
        //         setShowModalMensagem(true);
        //         setDadosModal({
        //             acao: true,
        //             label: "",
        //             tipo: "success",
        //             mensagem: "Registro cadastrado com sucesso!",
        //             display: "none",
        //             titulo: "Atenção"
        //         });
        //         // if (isSaveAndClose()) {
        //         //     setRedirecionar("/adm/usuarios");
        //         // } else {
        //         //     setRedirecionar(`/usuario/usuarios/detalhe/${result}`);
        //         // }
        //     })
        //     .catch((errors) => {
        //         setRemoveLoading(true);
        //         setShowModalMensagem(true);
        //         if (errors.response.status === 401) {
        //             setDadosModal({
        //                 acao: true,
        //                 label: "",
        //                 tipo: "info",
        //                 mensagem: "Sessão expirada!",
        //                 display: "none",
        //                 titulo: "Atenção"
        //             });
        //             logout();
        //             setRedirecionar("0");
        //             return;
        //         }
        //         setDadosModal({
        //             acao: true,
        //             label: "",
        //             tipo: "error",
        //             mensagem: errors.response !== undefined ? errors.response.data.mensagem : "Não foi possível criar a liga! Favor entrar em contato com a TI.",
        //             display: "none",
        //             titulo: "Atenção"
        //         });
        //     });

    }

    const handleRetornoDispensaJogador = async (codigoFranquia: number, codigoJogador: number) => {
        setIsLoading(true);
        setRemoveLoading(false);
        if (codigoFranquia === 0 || codigoFranquia === undefined) {
            setShowModalMensagem(true);
            setIsLoading(false);
            setRemoveLoading(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Favor informar a franquia!",
                display: "none",
                titulo: "Atenção"
            });

            setRedirecionar("");
            return
        }
        if (codigoJogador === 0 || codigoJogador === undefined) {
            setShowModalMensagem(true);
            setIsLoading(false);
            setRemoveLoading(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Favor informar o jogador!",
                display: "none",
                titulo: "Atenção"
            });
            setRedirecionar("");
            return
        }

        await FranquiaService.retornoDispensaJogador(codigoFranquia, codigoJogador, user.codUsuario)
            .then((result) => {
                setShowModalMensagem(true);
                setIsLoading(false);
                setRemoveLoading(true);
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "success",
                    mensagem: "Retorno da dispensa realizado com sucesso!",
                    display: "none",
                    titulo: "Atenção"
                });
                setRedirecionar("");
                return;

            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setIsLoading(false);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.data.statusHTTP === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível realizar a dispensa do jogador. Tente novamente mais tarde e caso o problema persistir, favor entrar em contato com a TI",
                    display: "none",
                    titulo: "Atenção"
                });
            });
    }

    const handleDispensarJogador = async (codigoFranquia: number, codigoJogador: number, nome: string) => {
        setIsLoading(true);
        setRemoveLoading(false);
        await FranquiaService.simularDispensaJogadorFranquia(codigoFranquia, codigoJogador)
            .then((result) => {
                setIsLoading(false);
                setRemoveLoading(true);
                let multa_Ano1 = result.dado.multa_Ano1.toString().trim() !== "0" ? ` | ${result.dado.descricao_Multa_Ano1}: R$ ${moedaRealLocaleValue(result.dado.multa_Ano1)}` : "R$0,00";
                let multa_Ano2 = result.dado.multa_Ano2.toString().trim() !== "0" ? ` | ${result.dado.descricao_Multa_Ano2}: R$ ${moedaRealLocaleValue(result.dado.multa_Ano2)}` : "";
                let multa_Ano3 = result.dado.multa_Ano3.toString().trim() !== "0" ? ` | ${result.dado.descricao_Multa_Ano3}: R$ ${moedaRealLocaleValue(result.dado.multa_Ano3)}` : "";
                let multa_Ano4 = result.dado.multa_Ano4.toString().trim() !== "0" ? ` | ${result.dado.descricao_Multa_Ano4}: R$ ${moedaRealLocaleValue(result.dado.multa_Ano4)}` : "";
                let multa_Ano5 = result.dado.multa_Ano5.toString().trim() !== "0" ? ` | ${result.dado.descricao_Multa_Ano5}: R$ ${moedaRealLocaleValue(result.dado.multa_Ano5)}` : "";
                let resp = multa_Ano1?.concat(multa_Ano2).concat(multa_Ano3).concat(multa_Ano4).concat(multa_Ano5);
                setShowModalEvent(true);
                setDadosModalEvent({
                    acao: true,
                    label: "Dispensar",
                    tipo: "info",
                    mensagem: `Deseja dispensar o jogador  ${nome} `,
                    display: "none",
                    titulo: "Atenção",
                    evento: "dispensarJogador",
                    info: {
                        codigoJogador: codigoJogador,
                        codigoFranquia: codigoFranquia,
                        mensagemAdicional: `Multas: ${resp}`,
                        style: { color: "red", fontWeight: "bold", wordWrap: "break-word", whiteSpace: "pre-line" }
                    }
                });
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setIsLoading(false);
                if (errors.response !== undefined) {
                    if (errors.response.data.statusHTTP === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar("");
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível realizar a dispensa do jogador. Tente novamente mais tarde e caso o problema persistir, favor entrar em contato com a TI",
                    display: "none",
                    titulo: "Atenção"
                });
                setRedirecionar("");
            });
    }

    const handleRetornoInserirJogador = async (codigoFranquia: number, codigoJogador: number) => {
        setIsLoading(true);
        setRemoveLoading(false);
        if (codigoFranquia === 0 || codigoFranquia === undefined) {
            setShowModalMensagem(true);
            setIsLoading(false);
            setRemoveLoading(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Favor informar a franquia!",
                display: "none",
                titulo: "Atenção"
            });

            setRedirecionar("");
            return
        }
        if (codigoJogador === 0 || codigoJogador === undefined) {
            setShowModalMensagem(true);
            setIsLoading(false);
            setRemoveLoading(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Favor informar o jogador!",
                display: "none",
                titulo: "Atenção"
            });
            setRedirecionar("");
            return
        }
        if (qtdAnoContrato === undefined || qtdAnoContrato <= 0) {
            setIsLoading(false);
            setRemoveLoading(true);
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Favor informar a quantidade anos!",
                display: "none",
                titulo: "Atenção"
            });

            return;
        }
        if (tipoSalario1 === undefined || tipoSalario1 <= 0) {
            setIsLoading(false);
            setRemoveLoading(true);
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Favor informar o tipo do salario 1!",
                display: "none",
                titulo: "Atenção"
            });

            return;
        }
        if (valorSalario1 === undefined || valorSalario1 === "") {
            setIsLoading(false);
            setRemoveLoading(true);
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Favor informar o valor do salário 1!",
                display: "none",
                titulo: "Atenção"
            });

            return;
        }

        const dados: IDadosCadastroPorFranquia = {
            codigo_Liga: Number(codigoLiga),
            codigo_Franquia: codigoFranquia !== null ? codigoFranquia : 0,
            codigo_Jogador: Number(selectedIdCompleteInserir),
            posicao_1: listaPosicoes.find(f=> f.codigo === posicao1)?.label ,
            posicao_2:  listaPosicoes.find(f=> f.codigo === posicao2)?.label,
            posicao_3:  listaPosicoes.find(f=> f.codigo === posicao3)?.label,
            salario_1: valorSalario1,
            tipo_Salario_1: tipoSalario1,
            salario_2: valorSalario2 === "" ? null : valorSalario2,
            tipo_Salario_2: tipoSalario2 === 0 ? null : tipoSalario2,
            salario_3: valorSalario3 === "" ? null : valorSalario3,
            tipo_Salario_3: tipoSalario3 === 0 ? null :tipoSalario3,
            salario_4: valorSalario4 === "" ? null : valorSalario4,
            tipo_Salario_4: tipoSalario4 === 0 ? null :tipoSalario4,
            salario_5: valorSalario5 === "" ? null : valorSalario5,
            tipo_Salario_5: tipoSalario5 === 0 ? null :tipoSalario5,
            salario_6: valorSalario6 === "" ? null : valorSalario6,
            tipo_Salario_6: tipoSalario6 === 0 ? null :tipoSalario6,
            quantidade_Anos_Contrato: qtdAnoContrato,
            restrito: chkRestrito,
            draftado: chkDraftado,
            codUsuCriacao: user.codUsuario,
        }

        FranquiaService.CadastrarJogadorPorFranquia(dados)
            .then((result) => {
                setIsLoading(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "success",
                    mensagem: "Jogador cadastrado com sucesso!",
                    display: "none",
                    titulo: "Atenção"
                });

                handleLimparCampos();
                //setRedirecionar("0");
            })
            .catch((errors) => {
                setIsLoading(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                console.log(errors);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível realizar a dispensa! Favor entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
            });
    }

    const handleLimparCampos = () => {
        setPosicao1(0);
        setPosicao2(0);
        setPosicao3(0);
        setTipoSalario1(0);
        setValorSalario1("");
        setTipoSalario2(0);
        setValorSalario2("");
        setTipoSalario3(0);
        setValorSalario3("");
        setTipoSalario4(0);
        setValorSalario4("");
        setTipoSalario5(0);
        setValorSalario5("");
        setTipoSalario6(0);
        setValorSalario6("");
        setFranquiaFiltroRetornoInserir(0);
        setQtdAnoContrato(0);
        setSelectedIdComplete(0);
        setChkRestrito(false);
        setChkDraftado(false);


    }

    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const handleSelectedFranquia = async (e: { target: { name: string; value: any; }; }) => {

        setFranquiaFiltro(Number(e.target.value));

        if (Number(e.target.value) > 0) {
            handleCarregarDadosJogadores(Number(e.target.value));
        }
    }

    const carregaPosicao = (posicao_1: string, posicao_2: string | null, posicao_3: string | null) => {

        let posicoes = `${UtilidadeService.verificaTipoPosicao(posicao_1)} ${posicao_2 !== null ? " | " : ""} ${posicao_2 !== null ? UtilidadeService.verificaTipoPosicao(posicao_2) : ""} ${posicao_3 !== null ? " | " : ""} ${posicao_3 !== null ? UtilidadeService.verificaTipoPosicao(posicao_3) : ""}`;

        let qtd = posicoes.split("|").length;
        let arrImagens = posicoes.split("|");

        let imgs = qtd === 1 ? <img src={`../${arrImagens[0]}`} alt={"img1"} width={UtilidadeService.isMobile() ? 15 : 20} height={UtilidadeService.isMobile() ? 15 : 20} style={{ borderRadius: "50%", fontSize: UtilidadeService.isMobile() ? "10" : "18" }} />
            : qtd === 2 ?
                <>  <img src={`../${arrImagens[0]}`} alt={"img1"} width={UtilidadeService.isMobile() ? 15 : 20} height={UtilidadeService.isMobile() ? 15 : 20} style={{ borderRadius: "50%", fontSize: UtilidadeService.isMobile() ? "10" : "18" }} />
                    <img src={`../${arrImagens[1].trim()}`} alt={"img2"} width={UtilidadeService.isMobile() ? 15 : 20} height={UtilidadeService.isMobile() ? 15 : 20} style={{ borderRadius: "50%", marginLeft: 4, fontSize: UtilidadeService.isMobile() ? "10" : "18" }} />
                </>
                : <> <img src={`../${arrImagens[0]}`} alt={"img1"} width={UtilidadeService.isMobile() ? 15 : 20} height={UtilidadeService.isMobile() ? 15 : 20} style={{ borderRadius: "50%", fontSize: UtilidadeService.isMobile() ? "10" : "18" }} />
                    <img src={`../${arrImagens[1].trim()}`} alt={"img2"} width={UtilidadeService.isMobile() ? 15 : 20} height={UtilidadeService.isMobile() ? 15 : 20} style={{ borderRadius: "50%", marginLeft: 4, fontSize: UtilidadeService.isMobile() ? "10" : "18" }} />
                    <img src={`../${arrImagens[2].trim()}`} alt={"img3"} width={UtilidadeService.isMobile() ? 15 : 20} height={UtilidadeService.isMobile() ? 15 : 20} style={{ borderRadius: "50%", marginLeft: 4, fontSize: UtilidadeService.isMobile() ? "10" : "18" }} />
                </>

        return imgs
    }

    return (
        <LayoutBaseDePagina titulo={`Comissário da Liga: ${nomeLiga}`}
            barraDeFerramentas={
                <FerramentasDeDetalhe
                    mostrarBotaoApagar={false}
                    mostrarBotaoNovo={false}
                    mostrarBotaoSalvar={false}
                    aoClicarEmSalvar={save}
                    aoClicarEmSalvarEFechar={saveAndClose}
                    aoClicarEmVoltar={() => navigate(-1)}
                />
            }
        >
            {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <VForm ref={formRef} onSubmit={handleSave}>
                <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                    <Grid container direction="column" padding={2} spacing={2}>
                        <Grid container direction="column" padding={2} spacing={2}>
                            <Grid alignItems="center" justifyContent="center" width="100%">
                                <Paper>
                                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                        <Tabs value={value} onChange={handleChangeTabs} variant="scrollable"
                                            scrollButtons
                                            sx={{
                                                [`& .${tabsClasses.scrollButtons}`]: {
                                                    '&.Mui-disabled': { opacity: 0.3 },
                                                },
                                            }}
                                        >
                                            <Tab label="Dispensar Jogador"  {...a11yProps(0)} />
                                            <Tab label="Retorno Dispensa"{...a11yProps(1)} />
                                            <Tab label="Inserir Jogador"{...a11yProps(2)} />
                                        </Tabs>
                                    </Box>
                                    <TabPanel value={value} index={0}>
                                        {!removeLoading && <Loading />}
                                        <Grid container size={{ xs: 12, sm: 12, md: 12 }} direction="row" display={"grid"} padding={2} spacing={2}>
                                            <Grid container size={{ xs: 12, sm: 12, md: 12 }} padding={UtilidadeService.isMobile() ? 2 : 1}  >
                                                <Grid size={{ xs: 12, sm: 12 }} >
                                                    <Typography variant="h6">Dispensar Jogador </Typography>
                                                    <hr />
                                                </Grid>
                                                <Grid container size={{ xs: 12, sm: 12, md: 12 }} margin={1} padding={UtilidadeService.isMobile() ? 2 : 1}  >
                                                    <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                        <FormControl fullWidth disabled={isLoading}>
                                                            <InputLabel id="demo-simple-select-label">Franquia</InputLabel>
                                                            <Select
                                                                variant="outlined"
                                                                native={false}
                                                                value={franquiaFiltro}
                                                                label="Franquia"
                                                                onChange={handleSelectedFranquia}
                                                            >
                                                                <MenuItem value={0}>Selecione</MenuItem>
                                                                {
                                                                    lstFraqnuias.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                                }
                                                            </Select>
                                                        </FormControl >
                                                    </Grid>
                                                </Grid>
                                                <Grid container size={12} direction="column"  >
                                                    {estatisticasRows.length > 0 && (
                                                        <Grid size={{ xs: 12, sm: 12 }}   >
                                                            <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: "100%" }}>
                                                                <Table>
                                                                    <TableHead sx={{ padding: "8px" }}>
                                                                        <TableRow>
                                                                            <StyledTableCell align="center">FOTO</StyledTableCell>
                                                                            <StyledTableCell>NOME</StyledTableCell>
                                                                            <StyledTableCell align="center">POSIÇÃO</StyledTableCell>
                                                                            <StyledTableCell align="right" style={{ width: "7%" }}>{ano1}</StyledTableCell>
                                                                            <StyledTableCell align="right" style={{ width: "7%" }}>{ano2}</StyledTableCell>
                                                                            <StyledTableCell align="right" style={{ width: "7%" }}>{ano3}</StyledTableCell>
                                                                            <StyledTableCell align="right" style={{ width: "7%" }}>{ano4}</StyledTableCell>
                                                                            <StyledTableCell align="right" style={{ width: "7%" }}>{ano5}</StyledTableCell>
                                                                            <StyledTableCell colSpan={3} align="center">AÇÕES</StyledTableCell>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {estatisticasRows.slice(0, 20).map(row => (
                                                                            <StyledTableRow key={row.codigo_Jogador} >
                                                                                <StyledTableCell style={{ cursor: "pointer" }} align="center"><img src={row.foto_Jogador === null ? showImagemJogador : row.foto_Jogador} alt={row.nome_Jogador} width={45} height={45} /></StyledTableCell>
                                                                                <StyledTableCell style={{ cursor: "pointer" }} >{row.nome_Jogador}
                                                                                    <span style={{ color: "#ED59BC" }}>
                                                                                        {
                                                                                            row.restrito === true && row.draftado === false ? " ®" :
                                                                                                row.restrito === false && row.draftado === true ? <span style={{ color: "#59cbed" }}>&nbsp;Ð</span> :
                                                                                                    row.restrito === true && row.draftado === true ? <><span style={{ color: "#ED59BC" }}>&nbsp;®</span> <span style={{ color: "#59cbed" }}>&nbsp;Ð</span></> : ""
                                                                                        }
                                                                                    </span>
                                                                                </StyledTableCell>
                                                                                <StyledTableCell style={{ cursor: "pointer" }} align="center">{carregaPosicao(row.posicao_1, row.posicao_2, row.posicao_3)}</StyledTableCell>
                                                                                <StyledTableCell style={{ width: "10%", textAlign: "end", cursor: "pointer", color: (row.contundido || row.fora_NBA) ? "red" : TipoSalario.find(f => f.codigo === row.tipo_Salario_1)?.color }}>{row.salario_1 === null ? "-" : moedaRealLocaleValue(row.salario_1)}</StyledTableCell>
                                                                                <StyledTableCell style={{ width: "10%", textAlign: "end", cursor: "pointer", color: (row.contundido || row.fora_NBA) ? "red" : row.tipo_Salario_2 === null ? "auto" : TipoSalario.find(f => f.codigo === row.tipo_Salario_2)?.color }}>{row.salario_2 === null ? "-" : moedaRealLocaleValue(row.salario_2)}</StyledTableCell>
                                                                                <StyledTableCell style={{ width: "10%", textAlign: "end", cursor: "pointer", color: (row.contundido || row.fora_NBA) ? "red" : row.tipo_Salario_3 === null ? "auto" : TipoSalario.find(f => f.codigo === row.tipo_Salario_3)?.color }}>{row.salario_3 === null ? "-" : moedaRealLocaleValue(row.salario_3)}</StyledTableCell>
                                                                                <StyledTableCell style={{ width: "10%", textAlign: "end", cursor: "pointer", color: (row.contundido || row.fora_NBA) ? "red" : row.tipo_Salario_4 === null ? "auto" : TipoSalario.find(f => f.codigo === row.tipo_Salario_4)?.color }}>{row.salario_4 === null ? "-" : moedaRealLocaleValue(row.salario_4)}</StyledTableCell>
                                                                                <StyledTableCell style={{ width: "10%", textAlign: "end", cursor: "pointer", color: (row.contundido || row.fora_NBA) ? "red" : row.tipo_Salario_5 === null ? "auto" : TipoSalario.find(f => f.codigo === row.tipo_Salario_5)?.color }}>{row.salario_5 === null ? "-" : moedaRealLocaleValue(row.salario_5)}</StyledTableCell>

                                                                                {mercadoAberto || (row.salario_1 === null || Number(row.salario_1) === 0) ?
                                                                                    (
                                                                                        <StyledTableCell align="center" sx={{ padding: "2px" }}>
                                                                                            <Tooltip title="Dispensar">
                                                                                                <IconButton size="small" onClick={() => handleDispensarJogador(row.codigo_Franquia, row.codigo_Jogador, row.nome_Jogador)}>
                                                                                                    <Icon style={{ fontSize: UtilidadeService.isMobile() ? 20 : 24 }}>cancel</Icon>
                                                                                                </IconButton>
                                                                                            </Tooltip>
                                                                                        </StyledTableCell>
                                                                                    )
                                                                                    : <StyledTableCell> </StyledTableCell>
                                                                                }
                                                                                {/* {twoWay ?
                                                                                        (
                                                                                            <StyledTableCell align="center" sx={{ padding: "2px" }}>
                                                                                                <Tooltip title="Two Way">
                                                                                                    <IconButton
                                                                                                        size="small"
                                                                                                        onClick={() => handleTwoWay(Number(codigoLiga), row.codigo_Franquia, row.codigo_Jogador, row.nome_Jogador)}
                                                                                                    >
                                                                                                        <Icon style={{ fontSize: UtilidadeService.isMobile() ? 20 : 24 }}>assignment</Icon>
                                                                                                    </IconButton>
                                                                                                </Tooltip>
                                                                                            </StyledTableCell>
                                                                                        )
                                                                                        : <StyledTableCell> </StyledTableCell>
                                                                                    } */}
                                                                            </StyledTableRow >
                                                                        ))}
                                                                        {/* <StyledTableRow>
                                                                            <StyledTableCell align="right" colSpan={3} sx={{ cursor: "pointer" }} >
                                                                                MULTA
                                                                            </StyledTableCell>
                                                                            <StyledTableCell align="right" sx={{ color: "red" }}>
                                                                                {franquiaMultasAnualRows?.multa_Ano1 !== undefined ? moedaRealLocaleValue(franquiaMultasAnualRows?.multa_Ano1) : "-"}
                                                                            </StyledTableCell>
                                                                            <StyledTableCell align="right" sx={{ color: "red" }}>
                                                                                {franquiaMultasAnualRows?.multa_Ano2 !== undefined ? moedaRealLocaleValue(franquiaMultasAnualRows?.multa_Ano2) : "-"}
                                                                            </StyledTableCell>
                                                                            <StyledTableCell align="right" sx={{ color: "red" }}>
                                                                                {franquiaMultasAnualRows?.multa_Ano3 !== undefined ? moedaRealLocaleValue(franquiaMultasAnualRows?.multa_Ano3) : "-"}
                                                                            </StyledTableCell>
                                                                            <StyledTableCell align="right" sx={{ color: "red" }}>
                                                                                {franquiaMultasAnualRows?.multa_Ano4 !== undefined ? moedaRealLocaleValue(franquiaMultasAnualRows?.multa_Ano4) : "-"}
                                                                            </StyledTableCell>
                                                                            <StyledTableCell align="right" sx={{ color: "red" }}>
                                                                                {franquiaMultasAnualRows?.multa_Ano5 !== undefined ? moedaRealLocaleValue(franquiaMultasAnualRows?.multa_Ano5) : "-"}
                                                                            </StyledTableCell>
                                                                            <StyledTableCell align="right" colSpan={3}>
                                                                            </StyledTableCell>
                                                                        </StyledTableRow>
                                                                        <StyledTableRow>
                                                                            <StyledTableCell align="right" colSpan={3}>
                                                                                TOTAL
                                                                            </StyledTableCell>
                                                                            <StyledTableCell align="right">
                                                                                {moedaRealLocaleValue(somatorio1.toString())}
                                                                            </StyledTableCell>
                                                                            <StyledTableCell align="right">
                                                                                {moedaRealLocaleValue(somatorio2.toString())}
                                                                            </StyledTableCell>
                                                                            <StyledTableCell align="right">
                                                                                {moedaRealLocaleValue(somatorio3.toString())}
                                                                            </StyledTableCell>
                                                                            <StyledTableCell align="right">
                                                                                {moedaRealLocaleValue(somatorio4.toString())}
                                                                            </StyledTableCell>
                                                                            <StyledTableCell align="right">
                                                                                {moedaRealLocaleValue(somatorio5.toString())}
                                                                            </StyledTableCell>
                                                                            <StyledTableCell align="right" colSpan={3}>
                                                                            </StyledTableCell>
                                                                        </StyledTableRow>
                                                                        <StyledTableRow>
                                                                            <StyledTableCell align="right" colSpan={3} sx={{ cursor: "pointer" }}>
                                                                                PICKS
                                                                            </StyledTableCell>
                                                                            <StyledTableCell sx={{ wordWrap: "break-word", wordBreak: "break-word", minWidth: "145px", textAlign: "end" }}>
                                                                                {resumo_Picks_Ano1.length > 0 ? resumo_Picks_Ano1.map(m => (<Typography variant="body2">
                                                                                    {!m.protecao && !m.swap ? m.resumo
                                                                                        : !m.protecao && m.swap ? <Tooltip style={{ cursor: "pointer" }} title={`${m.resumo_Swap} - ${m.nome_Franquia_Melhor_Pick_Swap}`}><span style={{ color: "#fbc02d", cursor: "pointer" }}>{m.resumo} (S)</span></Tooltip>
                                                                                            : m.protecao && !m.swap ? <Tooltip style={{ cursor: "pointer" }} title={`(${m.inicio_Protecao} - ${m.fim_Protecao}) ${m.resumo_Protecao}`}><span style={{ color: "#fbc02d", cursor: "pointer" }}>{m.resumo} (P)</span></Tooltip>
                                                                                                : <Tooltip style={{ cursor: "pointer" }} title={`${m.resumo_Swap} - ${m.nome_Franquia_Melhor_Pick_Swap} - (${m.inicio_Protecao} - ${m.fim_Protecao}) ${m.resumo_Protecao} `}><span style={{ color: "#fbc02d", cursor: "pointer" }}>{m.resumo} (P/S)</span></Tooltip>}

                                                                                </Typography>)) : "-"}
                                                                            </StyledTableCell>
                                                                            <StyledTableCell sx={{ wordWrap: "break-word", wordBreak: "break-word", minWidth: "145px", textAlign: "end" }}>
                                                                                {resumo_Picks_Ano2.length > 0 ? resumo_Picks_Ano2.map(m => (<Typography variant="body2">
                                                                                    {!m.protecao && !m.swap ? m.resumo
                                                                                        : !m.protecao && m.swap ? <Tooltip style={{ cursor: "pointer" }} title={`${m.resumo_Swap} - ${m.nome_Franquia_Melhor_Pick_Swap}`}><span style={{ color: "#fbc02d", cursor: "pointer" }}>{m.resumo} (S)</span></Tooltip>
                                                                                            : m.protecao && !m.swap ? <Tooltip style={{ cursor: "pointer" }} title={`(${m.inicio_Protecao} - ${m.fim_Protecao}) ${m.resumo_Protecao}`}><span style={{ color: "#fbc02d", cursor: "pointer" }}>{m.resumo} (P)</span></Tooltip>
                                                                                                : <Tooltip style={{ cursor: "pointer" }} title={`${m.resumo_Swap} - ${m.nome_Franquia_Melhor_Pick_Swap} - (${m.inicio_Protecao} - ${m.fim_Protecao}) ${m.resumo_Protecao} `}><span style={{ color: "#fbc02d", cursor: "pointer" }}>{m.resumo} (P/S)</span></Tooltip>}

                                                                                </Typography>)) : "-"}
                                                                            </StyledTableCell>
                                                                            <StyledTableCell sx={{ wordWrap: "break-word", wordBreak: "break-word", minWidth: "145px", textAlign: "end" }}>
                                                                                {resumo_Picks_Ano3.length > 0 ? resumo_Picks_Ano3.map(m => (<Typography variant="body2">
                                                                                    {!m.protecao && !m.swap ? m.resumo
                                                                                        : !m.protecao && m.swap ? <Tooltip style={{ cursor: "pointer" }} title={`${m.resumo_Swap} - ${m.nome_Franquia_Melhor_Pick_Swap}`}><span style={{ color: "#fbc02d", cursor: "pointer" }}>{m.resumo} (S)</span></Tooltip>
                                                                                            : m.protecao && !m.swap ? <Tooltip style={{ cursor: "pointer" }} title={`(${m.inicio_Protecao} - ${m.fim_Protecao}) ${m.resumo_Protecao}`}><span style={{ color: "#fbc02d", cursor: "pointer" }}>{m.resumo} (P)</span></Tooltip>
                                                                                                : <Tooltip style={{ cursor: "pointer" }} title={`${m.resumo_Swap} - ${m.nome_Franquia_Melhor_Pick_Swap} - (${m.inicio_Protecao} - ${m.fim_Protecao}) ${m.resumo_Protecao} `}><span style={{ color: "#fbc02d", cursor: "pointer" }}>{m.resumo} (P/S)</span></Tooltip>}

                                                                                </Typography>)) : "-"}
                                                                            </StyledTableCell>
                                                                            <StyledTableCell sx={{ wordWrap: "break-word", wordBreak: "break-word", minWidth: "145px", textAlign: "end" }}>
                                                                                {resumo_Picks_Ano4.length > 0 ? resumo_Picks_Ano4.map(m => (<Typography variant="body2">
                                                                                    {!m.protecao && !m.swap ? m.resumo
                                                                                        : !m.protecao && m.swap ? <Tooltip style={{ cursor: "pointer" }} title={`${m.resumo_Swap} - ${m.nome_Franquia_Melhor_Pick_Swap}`}><span style={{ color: "#fbc02d", cursor: "pointer" }}>{m.resumo} (S)</span></Tooltip>
                                                                                            : m.protecao && !m.swap ? <Tooltip style={{ cursor: "pointer" }} title={`(${m.inicio_Protecao} - ${m.fim_Protecao}) ${m.resumo_Protecao}`}><span style={{ color: "#fbc02d", cursor: "pointer" }}>{m.resumo} (P)</span></Tooltip>
                                                                                                : <Tooltip style={{ cursor: "pointer" }} title={`${m.resumo_Swap} - ${m.nome_Franquia_Melhor_Pick_Swap} - (${m.inicio_Protecao} - ${m.fim_Protecao}) ${m.resumo_Protecao} `}><span style={{ color: "#fbc02d", cursor: "pointer" }}>{m.resumo} (P/S)</span></Tooltip>}

                                                                                </Typography>)) : "-"}
                                                                            </StyledTableCell>
                                                                            <StyledTableCell sx={{ wordWrap: "break-word", wordBreak: "break-word", minWidth: "145px", textAlign: "end" }}>
                                                                                {resumo_Picks_Ano5.length > 0 ? resumo_Picks_Ano5.map(m => (<Typography variant="body2">
                                                                                    {!m.protecao && !m.swap ? m.resumo
                                                                                        : !m.protecao && m.swap ? <Tooltip style={{ cursor: "pointer" }} title={`${m.resumo_Swap} - ${m.nome_Franquia_Melhor_Pick_Swap}`}><span style={{ color: "#fbc02d", cursor: "pointer" }}>{m.resumo} (S)</span></Tooltip>
                                                                                            : m.protecao && !m.swap ? <Tooltip style={{ cursor: "pointer" }} title={`(${m.inicio_Protecao} - ${m.fim_Protecao}) ${m.resumo_Protecao}`}><span style={{ color: "#fbc02d", cursor: "pointer" }}>{m.resumo} (P)</span></Tooltip>
                                                                                                : <Tooltip style={{ cursor: "pointer" }} title={`${m.resumo_Swap} - ${m.nome_Franquia_Melhor_Pick_Swap} - (${m.inicio_Protecao} - ${m.fim_Protecao}) ${m.resumo_Protecao} `}><span style={{ color: "#fbc02d", cursor: "pointer" }}>{m.resumo} (P/S)</span></Tooltip>}

                                                                                </Typography>)) : "-"}
                                                                            </StyledTableCell>
                                                                            <StyledTableCell colSpan={3}>
                                                                            </StyledTableCell>
                                                                        </StyledTableRow> */}
                                                                    </TableBody>
                                                                </Table>
                                                            </TableContainer>
                                                        </Grid>
                                                    )}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </TabPanel>
                                    <TabPanel value={value} index={1}>
                                        {!removeLoading && <Loading />}
                                        <Grid container size={{ xs: 12, sm: 12, md: 12 }} direction="row" display={"grid"} padding={1} spacing={2}>
                                            <Grid size={{ xs: 12, sm: 12 }} padding={1} >
                                                <Typography variant="h6">Retorno Jogador Dispensado </Typography>
                                                <hr />
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12, md: 12 }} margin={1} padding={UtilidadeService.isMobile() ? 2 : 1}  >
                                                <Grid size={{ xs: 12, sm: 3, md: 3 }} paddingBottom={2}>
                                                    <Autocomplete
                                                        openText="Abrir"
                                                        closeText="Fechar"
                                                        noOptionsText="Sem opções"
                                                        loadingText="Carregando..."
                                                        options={opcoesAutoCompleteJogador}
                                                        loading={isLoading}
                                                        disabled={isLoading}
                                                        value={autoCompleteSelectedOption}
                                                        size={UtilidadeService.isMobile() ? "small" : "medium"}
                                                        onChange={(event, newValue) => { setSelectedIdComplete(newValue?.codigo); }}
                                                        popupIcon={isLoading ? <CircularProgress size={UtilidadeService.isMobile() ? 16 : 28} /> : undefined}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Jogador"
                                                                slotProps={{
                                                                    inputLabel: {
                                                                        style: {
                                                                            fontSize: UtilidadeService.isMobile() ? 13 : 16
                                                                        }
                                                                    }
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                    <FormControl fullWidth disabled={isLoading}>
                                                        <InputLabel id="demo-simple-select-label">Franquia</InputLabel>
                                                        <Select
                                                            variant="outlined"
                                                            native={false}
                                                            value={franquiaFiltroRetornoDispensa}
                                                            label="Franquia"
                                                            onChange={e => setFranquiaFiltroRetornoDispensa(Number(e.target.value))}
                                                        >
                                                            <MenuItem value={0}>Selecione</MenuItem>
                                                            {
                                                                lstFraqnuias.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                            }
                                                        </Select>
                                                    </FormControl >
                                                </Grid>
                                                <Grid size={{ xs: 6, sm: 2, md: 2 }} display={"flex"} justifyContent={"end"} alignSelf={"center"}>
                                                    <Button
                                                        color="primary"
                                                        variant="contained"
                                                        disableElevation
                                                        onClick={() => handleRetornoDispensaJogador(franquiaFiltroRetornoDispensa, Number(selectedIdComplete))}
                                                        startIcon={<Icon>change_circle</Icon>}
                                                    >
                                                        Retornar
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </TabPanel>
                                    <TabPanel value={value} index={2}>
                                        {!removeLoading && <Loading />}
                                        <Grid container size={{ xs: 12, sm: 12, md: 12 }} direction="row" display={"grid"} padding={1} spacing={2}>
                                            <Grid size={{ xs: 12, sm: 12 }} padding={1} >
                                                <Typography variant="h6">Inserir Jogador em uma Franquia </Typography>
                                                <hr />
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12, md: 12 }} margin={1} padding={UtilidadeService.isMobile() ? 2 : 1}  >
                                                <Grid size={{ xs: 12, sm: 3, md: 3 }} paddingBottom={2}>
                                                    <Autocomplete
                                                        openText="Abrir"
                                                        closeText="Fechar"
                                                        noOptionsText="Sem opções"
                                                        loadingText="Carregando..."
                                                        options={opcoesAutoCompleteInserirJogador}
                                                        loading={isLoading}
                                                        disabled={isLoading}
                                                        value={autoCompleteSelectedOptionInserir}
                                                        size={UtilidadeService.isMobile() ? "small" : "medium"}
                                                        onChange={(event, newValue) => { setSelectedIdCompleteInserir(newValue?.codigo); }}
                                                        popupIcon={isLoading ? <CircularProgress size={UtilidadeService.isMobile() ? 16 : 28} /> : undefined}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Jogador"
                                                                slotProps={{
                                                                    inputLabel: {
                                                                        style: {
                                                                            fontSize: UtilidadeService.isMobile() ? 13 : 16
                                                                        }
                                                                    }
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                    <FormControl fullWidth disabled={isLoading}>
                                                        <InputLabel id="demo-simple-select-label">Franquia</InputLabel>
                                                        <Select
                                                            variant="outlined"
                                                            native={false}
                                                            value={franquiaFiltroRetornoInserir}
                                                            label="Franquia"
                                                            onChange={e => setFranquiaFiltroRetornoInserir(Number(e.target.value))}
                                                        >
                                                            <MenuItem value={0}>Selecione</MenuItem>
                                                            {
                                                                lstFraqnuias.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                            }
                                                        </Select>
                                                    </FormControl >
                                                </Grid>
                                                <Grid size={{ xs: 6, sm: 3, md: 3 }} spacing={1} padding={1}>
                                                    <FormControl >
                                                        <FormControlLabel
                                                            control={<MuiCheckBox
                                                                name="chkDraftado"
                                                                checked={chkDraftado}
                                                                onChange={e => { setChkDraftado(e.target.checked); }}
                                                            />}
                                                            sx={{ '& .MuiFormControlLabel-label': { fontSize: 12 } }}
                                                            label="Draftado"
                                                            labelPlacement="start"
                                                        />
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 6, sm: 3, md: 3 }} spacing={1} padding={1}>
                                                    <FormControl>
                                                        <FormControlLabel
                                                            control={<MuiCheckBox
                                                                name="chkRestrito"
                                                                checked={chkRestrito}
                                                                onChange={e => setChkRestrito(e.target.checked)}
                                                            //disabled={!comissarioLiga}
                                                            />}
                                                            sx={{ '& .MuiFormControlLabel-label': { fontSize: 12 } }}
                                                            label="Restrito"
                                                            labelPlacement="start"
                                                        />
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 3, md: 3 }}>
                                                    <FormControl fullWidth>
                                                        <InputLabel id="demo-simple-select-label1">Posição 1</InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-label1"
                                                            id="demo-simple-select1"
                                                            label="Posição 1"
                                                            value={posicao1}
                                                            onChange={(e) => setPosicao1(Number(e.target.value))}
                                                            defaultValue={0}
                                                            style={{ fontSize: 12, height: UtilidadeService.isMobile() ? 40 : "auto" }}
                                                        >
                                                            <MenuItem key="0" value={0}>Selecione...</MenuItem>
                                                            {
                                                                listaPosicoes.map(qtd =>
                                                                    <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                                                                )
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 3, md: 3 }} >
                                                    <FormControl fullWidth>
                                                        <InputLabel id="demo-simple-select-label12">Posição 2</InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-label2"
                                                            id="demo-simple-select2"
                                                            label="Posição 2"
                                                            value={posicao2}
                                                            onChange={(e) => setPosicao2(Number(e.target.value))}
                                                            defaultValue={0}
                                                            style={{ fontSize: 12, height: UtilidadeService.isMobile() ? 40 : "auto" }}
                                                            disabled={posicao2 === null || listaPosicoes.length <= 1}
                                                        >
                                                            <MenuItem key="0" value={0}>Selecione...</MenuItem>
                                                            {
                                                                listaPosicoes.map(qtd =>
                                                                    <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                                                                )
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 3, md: 3 }} >
                                                    <FormControl fullWidth>
                                                        <InputLabel id="demo-simple-select-label3">Posição 3</InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-label3"
                                                            id="demo-simple-select3"
                                                            label="Posição 3"
                                                            value={posicao3}
                                                            onChange={(e) => setPosicao3(Number(e.target.value))}
                                                            defaultValue={0}
                                                            style={{ fontSize: 12, height: UtilidadeService.isMobile() ? 40 : "auto" }}
                                                            disabled={posicao3 === null || listaPosicoes.length <= 2}
                                                        >
                                                            <MenuItem key="0" value={0}>Selecione...</MenuItem>
                                                            {
                                                                listaPosicoes.map(qtd =>
                                                                    <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                                                                )
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                </Grid>

                                                <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="start" spacing={1}>
                                                    <Grid size={{ xs: 6, sm: 3, md: 3 }} spacing={1}>
                                                        <FormControl fullWidth disabled={isLoading}>
                                                            <InputLabel id="demo-simple-select-label">Quantidade Anos</InputLabel>
                                                            <Select
                                                                value={qtdAnoContrato}
                                                                label="Quantidade Anos"
                                                                defaultValue={0}
                                                                onChange={(e) => { setQtdAnoContrato(Number(e.target.value)); }}
                                                                style={{ fontSize: UtilidadeService.isMobile() ? 13 : "auto", height: UtilidadeService.isMobile() ? 40 : "auto" }}
                                                            >
                                                                <MenuItem value={0}>Selecione</MenuItem>
                                                                <MenuItem value={1}>1</MenuItem>
                                                                <MenuItem value={2}>2</MenuItem>
                                                                <MenuItem value={3}>3</MenuItem>
                                                                <MenuItem value={4}>4</MenuItem>
                                                                <MenuItem value={5}>5</MenuItem>
                                                                <MenuItem value={6}>6</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>
                                                <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="start" spacing={1}>
                                                    <Grid size={{ xs: 12, sm: 3, md: 3 }} >
                                                        <TextField
                                                            defaultValue={0}
                                                            fullWidth
                                                            type="text"
                                                            label="Salário 1"
                                                            value={valorSalario1}
                                                            onChange={(e) => { setValorSalario1(e.target.value) }}
                                                            slotProps={{
                                                                input: {
                                                                    inputComponent: NumericFormatCustom as any,
                                                                }
                                                            }}
                                                            style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, height: UtilidadeService.isMobile() ? 35 : "auto" }}
                                                        />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 2, md: 2 }} >
                                                        <FormControl fullWidth disabled={isLoading}>
                                                            <InputLabel id="demo-simple-select-label">Tipo Salário 1</InputLabel>
                                                            <Select
                                                                value={tipoSalario1}
                                                                label="Tipo Salário 1"
                                                                defaultValue={0}
                                                                onChange={(e) => { setTipoSalario1(Number(e.target.value)); }}
                                                                style={{ fontSize: UtilidadeService.isMobile() ? 13 : "auto", height: UtilidadeService.isMobile() ? 40 : "auto" }}
                                                            >
                                                                <MenuItem value={0}>Selecione</MenuItem>
                                                                {
                                                                    TipoSalario.map(qtd =>
                                                                        <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                                                                    )
                                                                }
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>
                                                <Grid container size={{ xs: 12, sm: 12 }} display={qtdAnoContrato >= 2 ? "flex" : "none"} justifyContent="start" spacing={1}>
                                                    <Grid size={{ xs: 12, sm: 3, md: 3 }} >
                                                        <TextField
                                                            defaultValue={0}
                                                            fullWidth
                                                            type="text"
                                                            label="Salário 2"
                                                            value={valorSalario2}
                                                            onChange={(e) => { setValorSalario2(e.target.value) }}
                                                            slotProps={{
                                                                input: {
                                                                    inputComponent: NumericFormatCustom as any,
                                                                }
                                                            }}
                                                            style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, height: UtilidadeService.isMobile() ? 35 : "auto" }}
                                                        />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 2, md: 2 }} >
                                                        <FormControl fullWidth disabled={isLoading}>
                                                            <InputLabel id="demo-simple-select-label">Tipo Salário 2</InputLabel>
                                                            <Select
                                                                value={tipoSalario2}
                                                                label="Tipo Salário 2"
                                                                defaultValue={0}
                                                                onChange={(e) => { setTipoSalario2(Number(e.target.value)); }}
                                                                style={{ fontSize: UtilidadeService.isMobile() ? 13 : "auto", height: UtilidadeService.isMobile() ? 40 : "auto" }}
                                                            >
                                                                <MenuItem value={0}>Selecione</MenuItem>
                                                                {
                                                                    TipoSalario.map(qtd =>
                                                                        <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                                                                    )
                                                                }
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>
                                                <Grid container size={{ xs: 12, sm: 12 }} display={qtdAnoContrato >= 3 ? "flex" : "none"} justifyContent="start" spacing={1}>
                                                    <Grid size={{ xs: 12, sm: 3, md: 3 }} >
                                                        <TextField
                                                            defaultValue={0}
                                                            fullWidth
                                                            type="text"
                                                            label="Salário 3"
                                                            value={valorSalario3}
                                                            onChange={(e) => { setValorSalario3(e.target.value) }}
                                                            slotProps={{
                                                                input: {
                                                                    inputComponent: NumericFormatCustom as any,
                                                                }
                                                            }}
                                                            style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, height: UtilidadeService.isMobile() ? 35 : "auto" }}
                                                        />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 2, md: 2 }} >
                                                        <FormControl fullWidth disabled={isLoading}>
                                                            <InputLabel id="demo-simple-select-label">Tipo Salário 3</InputLabel>
                                                            <Select
                                                                value={tipoSalario3}
                                                                label="Tipo Salário 3"
                                                                defaultValue={0}
                                                                onChange={(e) => { setTipoSalario3(Number(e.target.value)); }}
                                                                style={{ fontSize: UtilidadeService.isMobile() ? 13 : "auto", height: UtilidadeService.isMobile() ? 40 : "auto" }}
                                                            >
                                                                <MenuItem value={0}>Selecione</MenuItem>
                                                                {
                                                                    TipoSalario.map(qtd =>
                                                                        <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                                                                    )
                                                                }
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>
                                                <Grid container size={{ xs: 12, sm: 12 }} display={qtdAnoContrato >= 4 ? "flex" : "none"} justifyContent="start" spacing={1}>
                                                    <Grid size={{ xs: 12, sm: 3, md: 3 }} >
                                                        <TextField
                                                            defaultValue={0}
                                                            fullWidth
                                                            type="text"
                                                            label="Salário 4"
                                                            value={valorSalario4}
                                                            onChange={(e) => { setValorSalario4(e.target.value) }}
                                                            slotProps={{
                                                                input: {
                                                                    inputComponent: NumericFormatCustom as any,
                                                                }
                                                            }}
                                                            style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, height: UtilidadeService.isMobile() ? 35 : "auto" }}
                                                        />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 2, md: 2 }} >
                                                        <FormControl fullWidth disabled={isLoading}>
                                                            <InputLabel id="demo-simple-select-label">Tipo Salário 4</InputLabel>
                                                            <Select
                                                                value={tipoSalario4}
                                                                label="Tipo Salário 4"
                                                                defaultValue={0}
                                                                onChange={(e) => { setTipoSalario4(Number(e.target.value)); }}
                                                                style={{ fontSize: UtilidadeService.isMobile() ? 13 : "auto", height: UtilidadeService.isMobile() ? 40 : "auto" }}
                                                            >
                                                                <MenuItem value={0}>Selecione</MenuItem>
                                                                {
                                                                    TipoSalario.map(qtd =>
                                                                        <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                                                                    )
                                                                }
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>
                                                <Grid container size={{ xs: 12, sm: 12 }} display={qtdAnoContrato >= 5 ? "flex" : "none"} justifyContent="start" spacing={1}>
                                                    <Grid size={{ xs: 12, sm: 3, md: 3 }} >
                                                        <TextField
                                                            defaultValue={0}
                                                            fullWidth
                                                            type="text"
                                                            label="Salário 5"
                                                            value={valorSalario5}
                                                            onChange={(e) => { setValorSalario5(e.target.value) }}
                                                            slotProps={{
                                                                input: {
                                                                    inputComponent: NumericFormatCustom as any,
                                                                }
                                                            }}
                                                            style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, height: UtilidadeService.isMobile() ? 35 : "auto" }}
                                                        />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 2, md: 2 }} >
                                                        <FormControl fullWidth disabled={isLoading}>
                                                            <InputLabel id="demo-simple-select-label">Tipo Salário 4</InputLabel>
                                                            <Select
                                                                value={tipoSalario5}
                                                                label="Tipo Salário 5"
                                                                defaultValue={0}
                                                                onChange={(e) => { setTipoSalario5(Number(e.target.value)); }}
                                                                style={{ fontSize: UtilidadeService.isMobile() ? 13 : "auto", height: UtilidadeService.isMobile() ? 40 : "auto" }}
                                                            >
                                                                <MenuItem value={0}>Selecione</MenuItem>
                                                                {
                                                                    TipoSalario.map(qtd =>
                                                                        <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                                                                    )
                                                                }
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>
                                                <Grid container size={{ xs: 12, sm: 12 }} display={qtdAnoContrato >= 6 ? "flex" : "none"} justifyContent="start" spacing={1}>
                                                    <Grid size={{ xs: 12, sm: 3, md: 3 }} >
                                                        <TextField
                                                            defaultValue={0}
                                                            fullWidth
                                                            type="text"
                                                            label="Salário 6"
                                                            value={valorSalario6}
                                                            onChange={(e) => { setValorSalario6(e.target.value) }}
                                                            slotProps={{
                                                                input: {
                                                                    inputComponent: NumericFormatCustom as any,
                                                                }
                                                            }}
                                                            style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, height: UtilidadeService.isMobile() ? 35 : "auto" }}
                                                        />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 2, md: 2 }} >
                                                        <FormControl fullWidth disabled={isLoading}>
                                                            <InputLabel id="demo-simple-select-label">Tipo Salário 6</InputLabel>
                                                            <Select
                                                                value={tipoSalario6}
                                                                label="Tipo Salário 6"
                                                                defaultValue={0}
                                                                onChange={(e) => { setTipoSalario6(Number(e.target.value)); }}
                                                                style={{ fontSize: UtilidadeService.isMobile() ? 13 : "auto", height: UtilidadeService.isMobile() ? 40 : "auto" }}
                                                            >
                                                                <MenuItem value={0}>Selecione</MenuItem>
                                                                {
                                                                    TipoSalario.map(qtd =>
                                                                        <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                                                                    )
                                                                }
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>
                                                <Grid size={{ xs: 6, sm: 2, md: 2 }} display={"flex"} justifyContent={"start"} alignSelf={"center"}>
                                                    <Button
                                                        color="primary"
                                                        variant="contained"
                                                        disableElevation
                                                        onClick={() => handleRetornoInserirJogador(franquiaFiltroRetornoInserir, Number(selectedIdCompleteInserir))}
                                                        startIcon={<Icon>change_circle</Icon>}
                                                    >
                                                        Inserir
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </TabPanel>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </VForm>
        </LayoutBaseDePagina >
    );
};